export default "__VITE_ASSET__29e44f20__"